<template>
    <div v-if="allowed.read || viewMode === 'editor'" class="flex-root-column replacements-merc">
        <RibbonReplacementsMerc
            class="noselect"
            ref="ribbon"
            :view-mode="viewMode"

            :codeTexts="codeTexts"
            :columns="columns"

            :equipment="equipment"
            :equipments="equipments"

            :savable="dataChanged || viewMode === 'editor'"
            :removable="selectedRowIndex !== false"

            @updateView="updateView"
            @updateVisibleColumns="updateVisibleColumns"
            @codeTexts="codeTexts = $event"

            @addRow="addRow"
            @saveData="saveData(false)"
            @saveAndCopyData="saveData(true)"
            @removeRow="removeRow"
        />
        <div class="flex-root-row">
            <ReplacementsMercList
                v-show="viewMode !== 'editor'"
                ref="cedexReplacementsMerc"
                :code-texts="codeTexts"
                :columns="columns"

                :equipment="equipment"
                :data.sync="data"

                :survey-types="surveyTypes"
                :service-types="serviceTypes"
                :modes="modes"
                :view-types="viewTypes"
                :view-type-splits="viewTypeSplits"
                :container-heights="containerHeights"
                :machinery-manufacturers="machineryManufacturers"
                :machinery-types="machineryTypes"
                :survey-type-machinery="surveyTypeMachinery"
                :detailed-positions-by-component="detailedPositionsByComponent"
                :component-codes="componentCodes"
                :component-tags="componentTagsObject"
                :refrigerants="refrigerants"
                :damage-tags="damageTagsObject"
                :repair-codes="repairCodes"
                :repair-tags="repairTagsObject"
                :sts-codes="stsCodes"
                :mode-replacements="modeReplacements"

                @updateView="updateView"
                @filterData="filterData"
                @addRow="addRow"
                @editRow="editRow"
                @selectRow="selectRow"
            />
            <ReplacementsMercEditor
                v-if="editorOpened || viewMode === 'editor'"
                ref="cedexReplacementEditorMerc"
                :view-mode="viewMode"
                :equipment="equipment"
                :sts-codes="stsCodes"
                :mode-replacements="modeReplacements"

                :key="editRowIndex"
                :selected-values="selectedValues"
                :selectable-values="selectableValues"
                :selectable-dependencies="selectableDependencies"
                :survey-type-machinery="surveyTypeMachinery"
                :component-tags="componentTags"
                :damage-tags="damageTags"
                :repair-tags="repairTags"
                :detailed-positions-by-component="detailedPositionsByComponent"
                :refrigerant-components="refrigerantComponents"

                @closeEditor="editorOpened = false"
                @changed="handleDataChange"
                @showMessage="showMessage"
            />
        </div>
    </div>
</template>

<script>
import axios from "axios";
import i18n from "../../../i18n";
import ReplacementsMercList from "./ReplacementsMercList";
import RibbonReplacementsMerc from "./RibbonReplacementsMerc";
import ReplacementsMercEditor from "./ReplacementsMercEditor";
import equipments, {popupShowTime} from "../../../plugins/constants";
import authorization from "../../../plugins/authorization";

export default {
    name: "ReplacementsMerc",
    components: {ReplacementsMercEditor, RibbonReplacementsMerc, ReplacementsMercList},
    props: {
        viewMode: String
    },
    data() {
        return {
            initialData: {},
            defaultDataValue: [],
            dataLoaded: false,
            messageBox: {
                show:            false,
                content:         '',
                closeButtonText: 'ok',
                closeTimeout:    -1,
            },
            columns: [
                {id: 'surveyType',            title: 'Survey Type',            visible: true, width: '*', filter: 'data', required: true},
                {id: 'containerHeight',       title: 'Container Height',       visible: true, width: 50,  filter: 'data'},
                {id: 'serviceType',           title: 'Service Type',           visible: true, width: '*', filter: 'data', required: true},
                {id: 'mode',                  title: 'Mode',                   visible: true, width: 80,  filter: 'data'},
                {id: 'viewType',              title: 'Position',               visible: true, width: 120, filter: 'data', required: true},
                {id: 'detailedPosition',      title: 'Detailed Position',      visible: true, width: 120, filter: 'data'},
                {id: 'machineryManufacturer', title: 'Machinery Manufacturer', visible: true, width: 120, filter: 'data', required: true},
                {id: 'machineryType',         title: 'Machinery Type',         visible: true, width: 120, filter: 'data', required: true},
                {id: 'componentCode',         title: 'Component Code',         visible: true, width: 180, filter: 'data', required: true},
                {id: 'componentTag',          title: 'Component Tag',          visible: true, width: '*', filter: 'data'},
                {id: 'refrigerant',           title: 'Refrigerant Type',       visible: true, width: '*', filter: 'data'},
                {id: 'damageTag',             title: 'Damage Tag',             visible: true, width: '*', filter: 'data'},
                {id: 'repairCode',            title: 'Repair Code',            visible: true, width: 180, filter: 'data', required: true},
                {id: 'repairTag',             title: 'Repair Tag',             visible: true, width: '*', filter: 'data'},
                {id: 'length',                title: 'Length\n(mm)',           visible: true, width: 100},
                {id: 'width',                 title: 'Width\n(mm)',            visible: true, width: 100},
                {id: 'quantity',              title: 'Quantity',               visible: true, width: 100},
                {id: 'perimeter',             title: 'Perimeter\n(mm)',        visible: true, width: 100},
                {id: 'stsCode',               title: 'STS Code',               visible: true, width: 80,  filter: 'string'},
                {id: 'maxQuantity',           title: 'Max\nQuantity',          visible: true, width: 50},
                {id: 'wageHoursPerQuantity',  title: 'Hours per\nQuantity',    visible: true, width: 50},
                {id: 'materialCostValue',     title: 'Material\nCost\n(EUR)',  visible: true, width: 100},
                {id: 'materialCost',          title: 'Mat.\nCost',             visible: true, width: 50},
                {id: 'preparationTime',       title: 'Prep.\nTime',            visible: true, width: 50},
                {id: 'mappingDisabled',       title: 'Mapping\nDisabled',      visible: true, width: 70},
                {id: 'history',               title: 'History',                visible: true, width: 50},
            ],
            currentView: 'CEDEX Settings',
            codeTexts: true,

            surveyTypeMachinery: '',

            equipment: this.viewMode === 'editor'
                // try to read equipment from window value (set by Flow)
                ? this.$getExternalValue('replacementData', {}).equipment || 'carcass'
                : 'carcass',
            equipments: [],

            detailedPositions:  {},
            componentTags:      {},
            refrigerants:       {},
            damageTags:         {},
            repairCodes:        {},
            repairTags:         {},
            stsCodes:           {},
            viewTypeSplits:     {},
            detailedPositionsByComponent: {},
            modeReplacements:   [],

            data:               this.defaultDataValue,
            removedRows:        [],

            selectableDependencies: {},

            sortingColumn:      null,
            sortingDirection:   null,
            filters:            {},
            filterResultType:   'single',

            editorOpened:       false,
            dataChanged:        false,
            editRowIndex:       false,
            selectedRowIndex:   false,

            componentCodesWithDetailedPosition: ['CFG', 'RLA'],

            allowed: {
                read:  authorization.isAllowed('Settings/CEDEX Settings/Replacements/MERC'),
                write: authorization.isAllowed('Settings/CEDEX Settings/Replacements/MERC', authorization.write),
            },
        }
    },
    created() {
        this.loadInitialData();
    },
    methods: {
        loadInitialData: function() {
            axios
                .get('cedexReplacements/initialData')
                .then(response => {

                    this.initialData                  = response.data;

                    this.equipments                   = this.$convertObjectToObjectsInArray(
                        response.data.equipments,
                        'id',
                        'name'
                    );
                    this.viewTypeSplits               = response.data.viewTypeSplits;
                    this.detailedPositionsByComponent = response.data.detailedPositionsByComponent;
                    this.componentTags                = response.data.componentTags;
                    this.refrigerants                 = response.data.refrigerants;
                    this.refrigerantComponents        = response.data.refrigerantComponents;
                    this.damageTags                   = response.data.damageTags;
                    this.repairCodes                  = response.data.repairCodes;
                    this.repairTags                   = response.data.repairTags;
                    this.stsCodes                     = response.data.stsCodes;
                    this.modeReplacements             = response.data.modeReplacements;

                    this.surveyTypeMachinery = response.data.surveyTypeMachinery + '';

                    this.loadCodeDependencyData();

                    return response;
                }).catch(error => {
                    console.log(error);
                    this.showMessage(i18n.t('Replacements loading failed.'), 'error', popupShowTime);
                }).then(() => {
                    this.updateView('equipment', this.equipment);
                    this.dataLoaded = true;
                });
        },
        loadCodeDependencyData: async function() {
            axios.get('cedexReplacements/dependencyData').then(response => {

                this.selectableDependencies = response.data.dependencies;
                if (
                    typeof this.initialData === 'object'
                    && this.initialData
                    && Object.keys(this.initialData).length === 0
                    && Object.getPrototypeOf(this.initialData) === Object.prototype
                ) {
                    this.initialData.dependencies = response.data.dependencies;
                }

                return response;
            }).catch(error => {
                console.log(error);
                this.showMessage(i18n.t('Loading Code Dependency Data failed.'), 'error', popupShowTime);
            });
        },
        showMessage(content, type, close, buttonText) {
            this.$emit('showMessage', content, type, close, buttonText);
        },
        filterData(filters, showResultGroup) {
            this.updateView('filters', filters, showResultGroup);
        },
        addRow() {
            let rowIndex = this.data.length;
            this.data.push({
                id:                    null,
                surveyType:            '',
                containerHeight:       'all',
                serviceType:           '',
                viewType:              '',
                positionType:          '',
                detailedPosition:      '',
                machineryManufacturer: '',
                machineryType:         '',
                componentCode:         '',
                componentTag:          '',
                refrigerant:           '',
                damageTag:             '',
                repairCode:            '',
                repairTag:             '',
                lengthType:            '',
                lengthFrom:            '',
                lengthTo:              '',
                widthType:             '',
                widthFrom:             '',
                widthTo:               '',
                perimeterType:         '',
                perimeterFrom:         '',
                perimeterTo:           '',
                quantityType:          '',
                quantityFrom:          '',
                quantityTo:            '',
                // replacement data
                stsCode1:              '',
                stsCode2:              '',
                stsCode3:              '',
                stsCode4:              '',
                maxQuantity:           '',
                wageHoursPerQuantity:  '',
                materialCostValue:     '',
                materialCost:          '0',
                preparationTime:       '0',
                mappingDisabled:       '0',
            });
            this.dataChanged   = true;
            window.showBeforeUnload = true;
            this.editorOpened  = true;
            this.selectRow(rowIndex);
            this.$refs.cedexReplacementsMerc.currentPage = this.$refs.cedexReplacementsMerc.pageCount;
            this.$nextTick(() => {
                this.$refs.cedexReplacementsMerc.selectRow(rowIndex);
                this.$nextTick(() => {
                    let newLineElement = this.$el.querySelector('div.editor-table table tr.selected');
                    newLineElement.scrollIntoView({
                        block: 'end',
                        behavior: 'smooth'
                    });
                    newLineElement.classList.add('newLine');
                });
            });
        },
        editRow(index) {
            if (!this.allowed.write) {
                return;
            }
            this.$refs.cedexReplacementsMerc.selectRow(index);
            this.editRowIndex  = index;
            this.editorOpened  = true;
        },
        selectRow(index) {
            this.selectedRowIndex = index;
            if (this.editorOpened) {
                this.editRowIndex  = index;
            }
        },
        async removeRow() {
            // confirm
            const res = await this.$dialog.confirm({
                text: i18n.t('Do you really want to remove this replacement line?'),
                title: i18n.t('Delete CEDEX Replacement'),
                persistent: true,
                actions: {
                    false: i18n.t('No'),
                    true:  i18n.t('Yes'),
                },
            });

            if (!res) {
                return;
            }

            // add removed row to removedRows
            this.removedRows.push(this.data[this.selectedRowIndex].id);

            // remove row from data
            this.data.splice(this.selectedRowIndex, 1)
            this.selectedRowIndex = false;
            this.$refs.cedexReplacementsMerc.unselectRow();
            this.dataChanged = true;
            window.showBeforeUnload = true;
            this.editorOpened = false;
        },
        collectData() {
            return this.data;
        },
        collectDataMinified() {
            // collect data to save, minify keys and data for smaller JSON

            // short keys for smaller JSON
            let columnMap = {
                id:                    'id',
                surveyType:            'su',
                containerHeight:       'ch',
                serviceType:           'se',
                viewType:              'v',
                positionType:          'o',
                machineryManufacturer: 'mm',
                machineryType:         'mt',
                detailedPosition:      'p',
                componentCode:         'c',
                componentTag:          'tc',
                refrigerant:           'rf',
                damageTag:             'td',
                repairCode:            'r',
                repairTag:             'tr',
                lengthType:            'ly',
                lengthFrom:            'lf',
                lengthTo:              'lo',
                widthType:             'wy',
                widthFrom:             'wf',
                widthTo:               'wo',
                perimeterType:         'py',
                perimeterFrom:         'pf',
                perimeterTo:           'po',
                quantityType:          'qy',
                quantityFrom:          'qf',
                quantityTo:            'qo',
                stsCode1:              's1',
                stsCode2:              's2',
                stsCode3:              's3',
                stsCode4:              's4',
                maxQuantity:           'mq',
                wageHoursPerQuantity:  'w',
                materialCostValue:     'mv',
                materialCost:          'mc',
                preparationTime:       'pt',
                mappingDisabled:       'md',
            };

            let dataToSave = [];
            this.data.forEach((lineData) => { // each line
                let rowData = {};
                Object.keys(lineData).forEach((column) => { // each column
                    let columnKey = columnMap[column];
                    if (
                        lineData[column] === null
                        || lineData[column] === ''
                        || (
                            lineData[column] === '0'
                            && this.isBooleanColumn(column)
                        )
                        || typeof columnKey === 'undefined'
                    ) {
                        // if empty or default boolean false,
                        return false; // continue
                    }
                    rowData[columnKey] = lineData[column];
                });
                dataToSave.push(rowData);
            });

            return {
                data:        dataToSave,
                removedRows: this.removedRows
            };
        },

        collectRowData(lineIndex) {
            let data = this.data[lineIndex];
            if (typeof data !== 'undefined') {
                return data;
            } else {
                return {};
            }
        },
        validateData() {
            let correctMessage = '';
            for (let index in this.data) {
                let lineData = this.data[index];
                if (
                    // carcass & tank
                    (!this.isMachinery && !lineData.surveyType)
                    || (!this.isMachinery && lineData.position === '')
                    // machinery
                    || (this.isMachinery && !lineData.serviceType)
                    || (this.isMachinery && !lineData.machineryManufacturer)
                    // general
                    || lineData.componentCode === ''
                    || lineData.repairCode.length === 0
                ) {
                    correctMessage = this.isMachinery
                        ? 'Service Type, Machinery Manufacturer, Component and Repair Code have to be set.'
                        : 'Survey Type, Position, Component and Repair Code have to be set.'
                    ;
                } else if (
                    this.detailedPositionsByComponent[lineData.componentCode]
                    && (lineData.detailedPosition + '') === ''
                ) {
                    correctMessage = 'Selected Component Code needs a Detailed Position.';
                } else if (
                    !lineData.stsCode1
                    || !lineData.stsCode2
                    || !lineData.stsCode3
                    || !lineData.stsCode4
                ) {
                    correctMessage = 'STS codes 1-4 have to be set.';
                } else if (
                    this.isMachinery
                    && this.initialData.machineryTypes[lineData.machineryManufacturer]
                    && !lineData.machineryType
                ) {
                    correctMessage = 'A Machinery Type has to be selected.';
                }

                if (correctMessage) {
                    this.$refs.cedexReplacementsMerc.hideLoading();
                    // show message
                    this.showMessage(
                        i18n.t('The data of one or more lines is invalid.') + ' ' + i18n.t(correctMessage),
                        'error',
                        3000
                    );
                    // jump to edit invalid line
                    this.editRow(index);
                    return false;
                }
            }
            return true;
        },
        async saveData(/*keepData /*in editor*/) {
            const res = await this.$dialog.confirm({
                text: i18n.t('Do you really want to save your current settings?'),
                title: i18n.t('Save MERC+ CEDEX Replacements'),
                persistent: true,
                actions: {
                    false: 'No',
                    true:  'Yes',
                },
            });

            if (!res) {
                return;
            }

            this.$refs.cedexReplacementsMerc.showLoading();

            let dataMinified;
            let data;
            let removedRows = [];
            if (this.viewMode === 'editor') {

                this.data = [this.$refs.cedexReplacementEditorMerc.collectData()];
                dataMinified = this.collectDataMinified();
                data = dataMinified.data;
                removedRows = dataMinified.removedRows;

            } else {

                dataMinified = this.collectDataMinified();

                data = dataMinified.data;
                removedRows = dataMinified.removedRows;
                if (!this.validateData()) {
                    return;
                }

            }

            let params = new FormData();
            params.append('equipment', this.equipment);
            params.append('dataCount', data.length); // for validation
            params.append('data',      JSON.stringify(data));

            removedRows.forEach((removedRowId) => {
                params.append('deleted[]', removedRowId);
            });

            axios
                .post('cedexReplacements/saveMercReplacements', params)
                .then(response => {
                    this.$refs.cedexReplacementsMerc.hideLoading();
                    if (
                        response.status === 200
                        && response.data.success
                    ) {
                        this.showMessage(i18n.t('MERC+ Replacements saved.'), 'success', popupShowTime);
                        window.showBeforeUnload = false;
                        if (this.viewMode === 'editor') {
                            this.handleEditorViewModeComplete(this.data[0]);
                        }
                    } else {
                        this.showMessage(i18n.t('Data saving failed.'), 'error', popupShowTime);
                    }
                })
                .catch(error => {
                    this.$refs.cedexReplacementsMerc.hideLoading();
                    this.showMessage(i18n.t('Data saving failed.'), 'error', popupShowTime);
                    console.log(error);
                });
        },
        isBooleanColumn(column) {
            return ['materialCost', 'preparationTime', 'mappingDisabled'].includes(column);
        },
        updateView: function(updateType, updateValue, sourceOrOptions) {
            this[updateType] = updateValue;
            if (
                updateType !== 'viewMode'
                && updateValue === 'editor'
            ) {
                this.data = this.defaultDataValue;
                return;
            }
            if (
                updateType === 'layoutValue'
                && sourceOrOptions === 'replacements'
            ) {
                this.$refs.ribbon.setLayoutValue(updateValue);
            } else if (updateType === 'filters') {
                this.filterResultType = sourceOrOptions ? 'group' : 'single';
                if (!this.dataLoaded) {
                    return;
                }
            } else if (updateType === 'equipment') {
                // close editor on equipment change
                this.editorOpened = false;
                this.columns.forEach((column) => {
                    if (column.id === 'quantity') {
                        column.title = 'Quantity' + (updateValue === 'machinery' ? '\n(kg)' : '')
                    }
                })
            }

            if (updateType === 'sortingColumn') {
                this.sortingDirection = sourceOrOptions;
            } else {
                this.sortingColumn    = null;
                this.sortingDirection = null;
            }

            const triggerDataLoadTypes = ['equipment', 'sortingColumn', 'filters'];

            if (triggerDataLoadTypes.includes(updateType)) {
                this.$refs.cedexReplacementsMerc.showLoading();
                axios.post('cedexReplacements/loadMercReplacements', {
                    equipment:        this.equipment,
                    sortingColumn:    this.sortingColumn,
                    sortingDirection: this.sortingDirection,
                    filters:          this.filters,
                    filterResultType: this.filterResultType
                }).then(response => {
                    this.showMessage(i18n.t('Replacements loaded.'), 'success', popupShowTime);
                    this.$refs.cedexReplacementsMerc.hideLoading();
                    this.$refs.cedexReplacementsMerc.currentPage = 1;

                    if (
                        response.data.data
                        && response.data.data.length === 0
                    ) {
                        this.data = this.defaultDataValue;
                    } else {
                        this.data = response.data.data;
                        if (!this.data) {
                            this.data = this.defaultDataValue;
                        }
                    }
                    window.showBeforeUnload = false;
                });
            }
        },

        updateVisibleColumns: function(visibleColumnIds) {
            for (let columnIndex in this.columns) {
                this.$set(this.columns[columnIndex], 'visible', visibleColumnIds.includes(this.columns[columnIndex].id));
            }
        },

        handleDataChange(changed, data) {
            if (changed) {
                this.dataChanged = true;
                window.showBeforeUnload = true;
            }
            // viewType
            if (data.wageHoursPerQuantity && data.wageHoursPerQuantity.replace) {
                data.wageHoursPerQuantity = data.wageHoursPerQuantity.replace(',', '.');
            }

            if (data.materialCostValue && data.materialCostValue.replace) {
                data.materialCostValue = data.materialCostValue.replace(',', '.');
            }

            if (this.editRowIndex) {
                Object.assign(this.data[this.editRowIndex], data);
            } else {
                if (!this.data[0]) {
                    this.data.push(data);
                } else {
                    Object.assign(this.data[0], data);
                }
            }
        },

        handleEditorViewModeComplete(data) {
            // send data to editor caller (CLG: via event to iframe window parent)
            this.$setExternalValue('updateMercReplacement', {replacementData: data});
        },

        convertTagsToObject(tagType)
        {
            let tags = {};
            Object.keys(this[tagType + 'Tags']).forEach(tagId => {
                tags[tagId] = this[tagType + 'Tags'][tagId].name;
            });

            return tags;
        }
    },
    computed: {
        surveyTypes() {
            return this.initialData.surveyTypesWithContainerModule ? this.initialData.surveyTypesWithContainerModule[this.equipment] : {};
        },
        serviceTypes() {
            return this.initialData.serviceTypes ? this.initialData.serviceTypes : {};
        },
        containerHeights() {
            return this.initialData.containerHeights ? this.initialData.containerHeights : {};
        },
        machineryManufacturers() {
            return this.initialData.machineryManufacturer ? this.initialData.machineryManufacturer : {};
        },
        machineryTypes() {
            let machineryTypes = {};
            Object.keys(this.machineryManufacturers).forEach((manufacturerId) => {
                machineryTypes[manufacturerId] = {};
                if (
                    this.initialData.machineryTypes
                    && this.initialData.machineryTypes[manufacturerId]
                ) {
                    machineryTypes[manufacturerId] = this.initialData.machineryTypes[manufacturerId];
                }
            });

            return machineryTypes;
        },
        modes() {
            return this.isMachinery
                ? this.initialData.modesWithServiceType ? this.initialData.modesWithServiceType : {}
                : this.initialData.modesWithSurveyType  ? this.initialData.modesWithSurveyType  : {}
            ;
        },
        viewTypes() {
            return this.initialData.viewTypesWithContainerModule ? this.initialData.viewTypesWithContainerModule[this.equipment] : {};
        },
        componentCodes() {
            return this.initialData.componentsWithContainerModule ? this.initialData.componentsWithContainerModule[this.equipment] : {};
        },
        selectedValues() {
            if (this.viewMode === 'editor') {
                return this.$getExternalValue('replacementData', {});
            }
            if (this.editRowIndex === false) {
                return {};
            }

            return this.collectRowData(this.editRowIndex);
        },
        selectableValues() {
            let detailedPositionsByComponent = {};
            Object.keys(this.detailedPositionsByComponent).forEach((componentCode) => {
                detailedPositionsByComponent[componentCode] = this.$convertObjectToObjectsInArray(this.detailedPositionsByComponent[componentCode]);
                detailedPositionsByComponent[componentCode].push({
                    id:   '',
                    name: '',
                });
            });

            return {
                surveyTypes:                  this.$convertObjectToObjectsInArray(this.surveyTypes, 'id', 'name', false, true),
                serviceTypes:                 this.$convertObjectToObjectsInArray(this.serviceTypes, 'id', 'name', false, true),
                containerHeights:             this.$convertObjectToObjectsInArray(this.containerHeights, 'id', 'name', false, true),
                machineryManufacturers:       this.$convertObjectToObjectsInArray(this.machineryManufacturers, 'id', 'name', false, true),
                machineryTypes:               this.machineryTypes,
                modes:                        this.modes,
                viewTypes:                    this.$convertObjectToObjectsInArray(this.viewTypes),
                viewTypeSplits:               this.viewTypeSplits,
                detailedPositionsByComponent: detailedPositionsByComponent,
                componentCodes:               this.$convertObjectToObjectsInArray(this.componentCodes, 'id', 'name', true),
                refrigerants:                 this.$convertObjectToObjectsInArray(this.refrigerants),
                repairCodes:                  this.$convertObjectToObjectsInArray(this.repairCodes, 'id', 'name', true),
            }
        },
        isMachinery() {
            return this.equipment === equipments.MACHINERY;
        },
        componentTagsObject() { return this.convertTagsToObject('component'); },
        damageTagsObject()    { return this.convertTagsToObject('damage'); },
        repairTagsObject()    { return this.convertTagsToObject('repair'); }
    }
}
</script>
